<template>
  <div class="ma-4">
    <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />

    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-row>
        <v-col cols="4">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>

      <v-row>
        <v-col v-for="item in 3" :key="`line1_${item}`">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
        <v-col>
          <v-skeleton-loader class="mx-auto" type="button" />
        </v-col>
      </v-row>
    </v-sheet>

    <div v-show="!showSkeleton">
      <div class="text-h4">Relatório de Conferências</div>

      <v-form ref="form" class="mt-10">
        <v-row dense align="center">
          <v-col cols="3">
            <v-datetime-picker
              label="Data início"
              v-model="datetimestart"
              :date-picker-props="dateProps"
              :time-picker-props="timeProps"
              :text-field-props="textProps"
              date-format="dd/MM/yyyy"
              time-format="HH:mm"
            >
              <template slot="dateIcon">
                <v-icon>mdi-calendar-month</v-icon>
              </template>
              <template slot="timeIcon">
                <v-icon>mdi-clock-outline</v-icon>
              </template>
              <template slot="actions" slot-scope="{ parent }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      ripple
                      outlined
                      icon
                      color="darkRed"
                      @click="cancelEvent(parent)"
                      dark
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </template>
                  <span>Cancelar</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      ripple
                      outlined
                      icon
                      color="bluePcm"
                      @click="parent.okHandler"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      class="ml-2"
                    >
                      <v-icon>mdi-check</v-icon>
                    </v-btn>
                  </template>
                  <span>Confirmar</span>
                </v-tooltip>
              </template>
            </v-datetime-picker>
          </v-col>
          <v-col cols="3">
            <v-datetime-picker
              label="Data fim"
              v-model="datetimeend"
              :date-picker-props="dateProps"
              :time-picker-props="timeProps"
              :text-field-props="textProps"
              date-format="dd/MM/yyyy"
              time-format="HH:mm"
            >
              <template slot="dateIcon">
                <v-icon>mdi-calendar-month</v-icon>
              </template>

              <template slot="timeIcon">
                <v-icon>mdi-clock-outline</v-icon>
              </template>

              <template slot="actions" slot-scope="{ parent }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      ripple
                      outlined
                      icon
                      color="darkRed"
                      @click="cancelEvent(parent)"
                      dark
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </template>
                  <span>Cancelar</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      ripple
                      outlined
                      icon
                      color="bluePcm"
                      @click="parent.okHandler"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      class="ml-2"
                    >
                      <v-icon>mdi-check</v-icon>
                    </v-btn>
                  </template>
                  <span>Confirmar</span>
                </v-tooltip>
              </template>
            </v-datetime-picker>
          </v-col>
          <v-col cols="3">
            <v-select
              dense
              outlined
              multiple
              v-model="form.conferencias"
              :error-messages="conferenciasErrors"
              label="Conferência"
              :items="conferenciaItemsSelect"
              @input="$v.form.conferencias.$touch()"
              @blur="$v.form.conferencias.$touch()"
            >
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0">{{ item.text }}</span>
                <v-chip v-if="index === 1" small>
                  <span class="caption"> (+{{ form.conferencias.length - 1 }}) </span>
                </v-chip>
              </template>
              <template v-slot:prepend-item>
                <v-list-item ripple @click="toggleConferencias">
                  <v-list-item-action>
                    <v-icon :color="form.conferencias.length > 0 ? 'indigo darken-4' : ''">
                      {{ iconConferencia }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      Selecionar Todos
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>
            </v-select>
          </v-col>
          <v-col cols="3" align-self="stretch" class="text-right pr-4 pt-2">
            <v-btn dark color="bluePcm" @click="gerarRelatorio">Gerar</v-btn>
          </v-col>
        </v-row>

        <v-divider class="ma-2" />
      </v-form>

      <v-sheet class="pa-3" v-show="generateFirstReport && !showReport">
        <v-skeleton-loader class="mx-auto" type="table" />
      </v-sheet>

      <div
        v-show="
          !showSkeleton &&
            showReport &&
            getDadosRelatorioConferencia.length === 0
        "
      >
        <div class="text-h5">
          Não foram encontrados dados com os filtros selecionados.
        </div>
      </div>

      <div v-show="!showSkeleton && showReport && getDadosRelatorioConferencia.length > 0">
        <ExpansionPanel :dadosRelatorioConferencia="dadosRelatorioConferenciaPaginated" />

        <v-row dense v-if="lastPageItem" class="mt-2 mb-14" align="center" justify="center">
          <span class="ml-8 grey--text"> Itens: {{ initialItem }} - {{ finalItem }} de {{ totalItems }} Itens </span>
          <v-spacer />
          <div class="mr-2">
            <ListPagination
              :page="currentPage"
              :numberOfPages="lastPageItem"
              @firstPage="firstPage"
              @formerPage="formerPage"
              @nextPage="nextPage"
              @lastPage="lastPage"
            />
          </div>
        </v-row>

        <!-- <v-row dense class="mt-2" align="center">
          <v-col>
            <span class="ml-8 grey--text">
              Itens: {{ initialItem }} - {{ finalItem }} de {{ totalItems }}
              Itens
            </span>
          </v-col>
          <v-col cols="6" order="12" class="mr-8 text-right">
            <span class="mr-4 grey--text">Página {{ currentPage }} de {{ lastPageItem }}</span>
            <v-btn small dark icon color="bluePcm" @click="firstPage">
              <v-icon>mdi-chevron-double-left</v-icon>
            </v-btn>
            <v-btn small dark icon color="bluePcm" @click="formerPage">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn dark small icon color="bluePcm" @click="nextPage">
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
            <v-btn dark small icon color="bluePcm" @click="lastPage">
              <v-icon>mdi-chevron-double-right</v-icon>
            </v-btn>
          </v-col>
        </v-row> -->
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'

import Snackbar from '@/componentes/Snackbar'
import ListPagination from '@/componentes/ListPagination'
import { registerVuexModule } from '@/utils/vuexUtils'
import { initialAndFinalDateTextInputReportForm } from '@/mixins/initialAndFinalDateTextInputReportForm'

import relatorioConferenciasStore from '../_store'
import { validateData, validateComputed } from '../_validates'
import ExpansionPanel from '../_components/ExpansionPanel'

export default {
  name: 'RelatorioConferenciasHome',
  components: { Snackbar, ExpansionPanel, ListPagination },
  mixins: [initialAndFinalDateTextInputReportForm],
  data: () => ({
    form: {
      dataHoraInicio: '',
      dataHoraFim: '',
      conferencias: [],
    },
    conferenciaItemsSelect: [],
    dadosRelatorioConferenciaPaginated: [],
    dadosRelatorioConferencia: [],
    snackbar: false,
    showSkeleton: false,
    showReport: false,
    generateFirstReport: false,
    text: '',
    totalItems: 0,
    currentPage: 1,
    itemsPerPage: 20,
  }),

  validations: {
    ...validateData,
  },

  computed: {
    ...validateComputed,
    ...mapGetters('relatorioConferenciasModuleRelatoriosPABXStore', [
      'getConferencias',
      'getDadosRelatorioConferencia',
    ]),

    initialItem() {
      return 1 + (this.currentPage - 1) * this.itemsPerPage
    },

    finalItem() {
      if (this.initialItem + (this.itemsPerPage - 1) > this.dadosRelatorioConferencia.length) {
        return this.dadosRelatorioConferencia.length
      }
      return this.initialItem + (this.itemsPerPage - 1)
    },

    lastPageItem() {
      return Math.ceil(this.dadosRelatorioConferencia.length / this.itemsPerPage) || 0
    },

    todasConferenciasSelecionadas() {
      return this.form.conferencias.length === this.conferenciaItemsSelect.length
    },
    algumasConferenciasSelecionadas() {
      return this.form.conferencias.length > 0 && !this.todasConferenciasSelecionadas
    },

    iconConferencia() {
      if (this.todasConferenciasSelecionadas) return 'mdi-close-box'
      if (this.algumasConferenciasSelecionadas) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
  },

  async created() {
    this.showSkeleton = true

    registerVuexModule(this.$store, 'relatorioConferenciasModuleRelatoriosPABXStore', relatorioConferenciasStore)

    await this.listarTodasAsConferencias()

    this.conferenciaItemsSelect = this.getConferencias.map(conferencia => ({
      text: conferencia.description,
      value: conferencia._id,
    }))

    this.showSkeleton = false
  },

  methods: {
    ...mapActions('relatorioConferenciasModuleRelatoriosPABXStore', [
      'listarTodasAsConferencias',
      'gerarDadosRelatorio',
    ]),

    toggleConferencias() {
      this.$nextTick(() => {
        if (this.todasConferenciasSelecionadas) {
          this.form.conferencias.splice(0)
        } else {
          this.form.conferencias.splice(0)
          this.form.conferencias = this.conferenciaItemsSelect.map(conferencias => conferencias.value)
        }
      })
    },

    async gerarRelatorio() {
      if (this.datetimeend < this.datetimestart) {
        this.text = 'Data de fim não pode ser menor que data de início.'
        this.snackbar = true
        return
      }

      this.$v.$touch()
      if (this.$v.$error) {
        this.$vuetify.goTo(1, { duration: 1000, easing: 'easeOutCubic' })
        return
      }

      this.showReport = false
      this.generateFirstReport = true

      this.form.dataHoraInicio = moment(this.datetimestart).format('YYYY-MM-DD HH:mm:ss')
      this.form.dataHoraFim = moment(this.datetimeend).format('YYYY-MM-DD HH:mm:ss')

      await this.gerarDadosRelatorio(this.form)

      this.dadosRelatorioConferencia = [...this.getDadosRelatorioConferencia]

      if (this.currentPage !== 1) {
        this.currentPage = 1
      }

      this.dadosRelatorioConferenciaPaginated.splice(0)

      const conferenceReportDataLength =
        this.dadosRelatorioConferencia.length < this.itemsPerPage
          ? this.dadosRelatorioConferencia.length
          : this.itemsPerPage

      for (let i = 0; i < conferenceReportDataLength; i++) {
        this.dadosRelatorioConferenciaPaginated.push(this.dadosRelatorioConferencia[i])
      }

      this.totalItems = this.dadosRelatorioConferencia.length
      this.showReport = true
    },

    async firstPage() {
      if (this.currentPage > 1) {
        this.currentPage = 1
        this.updatePaginatedDate()
      }
    },

    async formerPage() {
      if (this.currentPage > 1) {
        this.currentPage -= 1
        this.updatePaginatedDate()
      }
    },

    async nextPage() {
      if (this.currentPage < this.lastPageItem) {
        this.currentPage += 1
        this.updatePaginatedDate()
      }
    },

    async lastPage() {
      if (this.currentPage < this.lastPageItem) {
        this.currentPage = this.lastPageItem
        this.updatePaginatedDate()
      }
    },

    updatePaginatedDate() {
      this.dadosRelatorioConferenciaPaginated.splice(0)

      const initialIndex = (this.currentPage - 1) * this.itemsPerPage
      const finalIndex = initialIndex + (this.itemsPerPage - 1)

      if (finalIndex + 1 > this.dadosRelatorioConferencia.length) {
        for (let i = initialIndex; i < this.dadosRelatorioConferencia.length; i++) {
          this.dadosRelatorioConferenciaPaginated.push(this.dadosRelatorioConferencia[i])
        }
      } else {
        for (let i = initialIndex; i <= finalIndex; i++) {
          this.dadosRelatorioConferenciaPaginated.push(this.dadosRelatorioConferencia[i])
        }
      }
    },
  },
}
</script>
